export const AVAILABILITY_MODE = {
  fixedDuration: 'fixed_duration',
  sameDayOnly: 'same_day_only',
  untilAnchoringVisitCompleted: 'until_anchoring_visit_completed',
  untilNextInstanceOpens: 'until_next_instance_opens',
  withdrawIfAnchoringVisitMissed: 'withdraw_if_anchoring_visit_missed',
}

export const AVAILABILITY_MODE_LABELS = {
  [AVAILABILITY_MODE.fixedDuration]: 'Open for a fixed duration',
  [AVAILABILITY_MODE.sameDayOnly]: 'Same day only',
  [AVAILABILITY_MODE.untilAnchoringVisitCompleted]: 'Until the anchoring visit is completed',
  [AVAILABILITY_MODE.untilNextInstanceOpens]: 'Until the next instance opens',
  [AVAILABILITY_MODE.withdrawIfAnchoringVisitMissed]: 'Withdraw if the anchoring visit is missed',
}

export const AVAILABILITY_MODE_OPTIONS = Object.keys(AVAILABILITY_MODE_LABELS).map(key => ({
  key,
  text: AVAILABILITY_MODE_LABELS[key],
}))

export const AVAILABILITY_MODE_PILLS = AVAILABILITY_MODE_OPTIONS.filter(
  option => option.key !== AVAILABILITY_MODE.fixedDuration,
)

/** Deploy clock (`deploy.time_of_day`) — independent of `availability.daily_window`. */
export const DEFAULT_DEPLOY_TIME_OF_DAY = '09:00'
